export enum sceneEnum {
    // 登录
    login,
    // 启动
    startapp,
    // 进入授信页面
    credit,
    // 进入用信流程
    // 2023.12.11修改顺序：withdraw为提现页提交，addication改为增验提交
    withdraw,
    // 增验
    addication,
    // 点击立即还款按钮
    paymoney00,
    // 点击全部还清按钮
    paymoney01,
    // 贷超入白和分流逻辑之前
    whiteuserDiversion
}

export enum sourceEnum {
    h5,
    h5_ios_58app,
    h5_ios_hjapp,
    h5_android_58app,
    h5_android_hjapp,
    h5_ios_sdk,
    h5_android_sdk,
    haojie_ios,
    haojie_android,
    // 微信小程序默认值，获取不到source时会传
    h5_xiaochengxu
}

